import "../../assets/style/grandprix.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircuitLayout from "../../components/CircuitLayout";
import CircuitTransition from "../../components/CircuitTransition";
import {
  faCircleInfo,
  faCalendarDay,
  faLocationPin,
  faRuler,
  faBacon,
  faMapLocation,
  faTrophy,
  faGaugeHigh,
  faNewspaper,
  faPen,
  faTrash,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { i18n } from "../../App";
import DateFormat from "../../components/DateFormat";
import Flag from "../../components/Flag";
import { DriverLink } from "../../components/FlagLink";
import ErrorPage from "../ErrorPage";
import { Link, useNavigate } from "react-router-dom";
import GrandPrixNavbar from "../../components/GrandPrix/GrandPrixNavbar";
import LoadingContent from "../../components/LoadingContent";
import SummaryData from "../../components/Historic/SummaryData";
import SummaryDrivers from "./index/SummaryDrivers";
import { useUser } from "../../components/UserContext";

const GrandPrix = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  let { grandprix } = useParams();
  const { superMode, user } = useUser() as any;
  const { t } = useTranslation();
  const [grandPrix, setGrandPrix] = useState<any>({
    name: "",
    pole_video: "",
    gp_video: "",
    conference: "",
    circuit_id: null,
    date: new Date(),
    circuit_name: "",
    layout: null,
    turns: 0,
    length: 0,
    flag_code: "unk",
    country: "",
    id: -1,
    champ_name: "",
    rally_circuits: "",
  });
  const [editingMilestoneIndex, setEditingMilestoneIndex] = useState<
    number | null
  >(null);
  const [editedMilestoneText, setEditedMilestoneText] = useState("");
  const [milestones, setMilestones] = useState([]);
  const [typeRaces, setTypeRaces] = useState(-1);
  const [drivers, setDrivers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [grandsPrixNames, setGrandsPrixNames] = useState([]);
  const [winner, setWinner] = useState([]);
  const [report, setReport] = useState<any>([]);

  const [poleman, setPoleman] = useState([]);
  const [fastestLap, setFastestLap] = useState([]);
  const [photoGP, setPhotoGP] = useState("");

  const [widthCont, setWidthCont] = useState("col-md-8");
  const [circuitContainer, setCircuitContainer] = useState(
    "gp-results-layout-container",
  );

  useEffect(() => {
    console.log(superMode, user);
    // 1. Reseteamos los contenedores a sus valores por defecto antes de cargar el nuevo GP
    setWidthCont("col-md-8");
    setCircuitContainer("gp-results-layout-container");
    setLoading(true);

    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/getGrandPrixByName`,
        {
          params: {
            name: grandprix,
            language: i18n.language,
          },
        },
      )
      .then(({ data }) => {
        document.title = "LVF1 - " + data.grand_prix.name;
        setMilestones(data.milestones);
        setDrivers(data.drivers);
        setTeams(data.teams);
        setGrandsPrixNames(data.grandprix_names);
        setWinner(data.winner);
        setPoleman(data.poleman);
        setFastestLap(data.fastestLap);
        setGrandPrix(data.grand_prix);
        setTypeRaces(data.type_races);
        setReport(data.report);

        if (
          data.grand_prix.gp_video === null ||
          data.grand_prix.pole_video === null
        ) {
          if (data.hasImage != null && data.hasImage)
            setPhotoGP(`/assets/ImagesGP/${data.grand_prix.id}.jpg`);
          else if (
            data.grand_prix.pole_video === null &&
            data.grand_prix.gp_video === null
          ) {
            setWidthCont("col-md-12");
          }
        }

        // 2. Si el nuevo GP no tiene hitos, aplicamos la clase especial
        if (data.milestones.length == 0) {
          setCircuitContainer("gp-results-layout-containerx2");
        }

        setLoading(false);
      })
      .catch(({ response }) => {
        setLoading(false);
        throw new Error(response?.data || response);
      });
  }, [i18n.language, grandprix]);
  const handleUpdateMilestone = (milestoneId: number, index: number) => {
    const baseURL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    axios
      .post(`${baseURL}/api/grandprix/updateMilestone`, {
        id: milestoneId,
        milestone: editedMilestoneText,
      })
      .then(() => {
        // Actualizamos el estado localmente para reflejar el cambio sin recargar
        const updatedMilestones: any = [...milestones];
        updatedMilestones[index].milestone = editedMilestoneText;
        setMilestones(updatedMilestones);
        setEditingMilestoneIndex(null);
      })
      .catch((error) => {
        console.error("Error updating milestone:", error);
      });
  };

  const handleDeleteMilestone = (milestoneId: number, index: number) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar este milestone?"))
      return;

    const baseURL =
      process.env.NODE_ENV === "development"
        ? "http://localhost:5500"
        : "https://ligavirtualf1.es:5500";

    axios
      .post(`${baseURL}/api/grandprix/deleteMilestone`, {
        id: milestoneId,
      })
      .then(() => {
        // Eliminamos el milestone del estado local
        const updatedMilestones = milestones.filter((_, i) => i !== index);
        setMilestones(updatedMilestones);
      })
      .catch((error) => {
        console.error("Error deleting milestone:", error);
      });
  };
  const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& significa toda la cadena coincidente
  };
  const getMilestoneLinked = (milestone: string | null): any => {
    if (milestone == null) return milestone;
    let milestone_array: any[] = [milestone];

    /* 1. DRIVERS: Ordenados estrictamente de mayor a menor longitud */
    const sortedDrivers = [...drivers].sort(
      (a: any, b: any) => b.username.length - a.username.length,
    );

    let milestone_transformed_drivers: any[] = sortedDrivers.reduce(
      (previous_milestone: any[], driver: any) => {
        let return_milestone: any[] = previous_milestone.slice();
        for (var i = 0; i < previous_milestone.length; i++) {
          if (
            previous_milestone[i].startsWith("{") ||
            !previous_milestone[i]
              .toLowerCase()
              .includes(driver.username.toLowerCase())
          ) {
            continue;
          }

          var escapedUsername = escapeRegExp(driver.username);
          var re = new RegExp("(" + escapedUsername + ")", "gi");
          var aux = previous_milestone[i].split(re);

          return_milestone.splice(i, 1);

          let offset = 0;
          for (var j = 0; j < aux.length; j++) {
            let segment: any = aux[j];
            if (segment.toLowerCase() === driver.username.toLowerCase()) {
              segment = "{DR}" + driver.username;
            }
            return_milestone.splice(i + offset, 0, segment);
            offset++;
          }
          i += offset - 1;
        }
        return return_milestone;
      },
      milestone_array,
    );

    /* 2. TEAMS: Ordenados de mayor a menor longitud */
    const sortedTeams = [...teams].sort(
      (a: any, b: any) => b.name.length - a.name.length,
    );

    let milestone_transformed_teams: any[] = sortedTeams.reduce(
      (previous_milestone: any[], team: any) => {
        let return_milestone: any[] = previous_milestone.slice();
        for (var i = 0; i < previous_milestone.length; i++) {
          if (
            previous_milestone[i].startsWith("{") ||
            !previous_milestone[i]
              .toLowerCase()
              .includes(team.name.toLowerCase())
          ) {
            continue;
          }

          var escapedTeam = escapeRegExp(team.name);
          var re = new RegExp("(" + escapedTeam + ")", "gi");
          var aux = previous_milestone[i].split(re);

          return_milestone.splice(i, 1);

          let offset = 0;
          for (var j = 0; j < aux.length; j++) {
            let segment: any = aux[j];
            if (segment.toLowerCase() === team.name.toLowerCase()) {
              segment = "{TE}" + team.name;
            }
            return_milestone.splice(i + offset, 0, segment);
            offset++;
          }
          i += offset - 1;
        }
        return return_milestone;
      },
      milestone_transformed_drivers,
    );

    /* 3. GPS: Ordenados de mayor a menor longitud */
    const sortedGps = [...grandsPrixNames].sort(
      (a: any, b: any) => b.name.length - a.name.length,
    );

    let milestone_transformed_gps: any[] = sortedGps.reduce(
      (previous_milestone: any[], gp: any) => {
        let return_milestone: any[] = previous_milestone.slice();
        for (var i = 0; i < previous_milestone.length; i++) {
          if (
            previous_milestone[i].startsWith("{") ||
            !previous_milestone[i].toLowerCase().includes(gp.name.toLowerCase())
          ) {
            continue;
          }

          var escapedGp = escapeRegExp(gp.name);
          var re = new RegExp("(" + escapedGp + ")", "gi");
          var aux = previous_milestone[i].split(re);

          return_milestone.splice(i, 1);

          let offset = 0;
          for (var j = 0; j < aux.length; j++) {
            let segment: any = aux[j];
            if (segment.toLowerCase() === gp.name.toLowerCase()) {
              segment = "{GP}" + gp.name;
            }
            return_milestone.splice(i + offset, 0, segment);
            offset++;
          }
          i += offset - 1;
        }
        return return_milestone;
      },
      milestone_transformed_teams,
    );

    /* Renderizado final de los componentes React */
    let output_milestone: any = <></>;
    const output_milestone2 = milestone_transformed_gps.reduce(
      (previous_milestone: any, current_position: any) => {
        if (current_position.startsWith("{DR}")) {
          let driver = current_position.split("{DR}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Driver")}/${encodeURIComponent(driver)}`}
                className="driver"
              >
                {driver}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{TE}")) {
          let team = current_position.split("{TE}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:Team")}/${encodeURIComponent(team)}`}
                className="driver"
              >
                {team}
              </Link>
            </>
          );
        } else if (current_position.startsWith("{GP}")) {
          let gp = current_position.split("{GP}")[1];
          return (
            <>
              {previous_milestone}
              <Link
                to={`${t("routes:GrandPrix")}/${encodeURIComponent(
                  gp.replace(/ /g, ""),
                )}`}
                className="driver"
              >
                {gp}
              </Link>
            </>
          );
        }
        return (
          <>
            {previous_milestone}
            <span>{current_position}</span>
          </>
        );
      },
      output_milestone,
    );

    return output_milestone2;
  };
  const processMilestoneAuto = (milestone: {
    key: string;
    param1: string;
    param2?: string;
    param3?: string;
    param4?: string;
    grand_prix_event_id: number;
    catalog: number;
  }) => {
    const formatList = (value?: string) => {
      if (!value) return value;

      const items = value
        .split(" | ")
        .map((v) => v.trim())
        .filter(Boolean);

      return new Intl.ListFormat(i18n.language, {
        style: "long",
        type: "conjunction",
      }).format(items);
    };

    const translationValues: Record<string, string> = {
      param1: formatList(milestone.param1)!,
    };
    const plural =
      milestone.param1 != null && milestone.param1.split(" | ").length > 1
        ? "_plural"
        : "";
    const datesP4 = [
      "PoleAfterTime",
      "RaceAfterTime",
      "WinAfterTime",
      "PodiumAfterTime",
      "FastestLapAfterTime",
      "PointsAfterTime",
      "HatTricksAfterTime",
      "GrandChelemAfterTime",
      "RetAfterTimeWithRecord",
      "RetAfterTime",
    ];
    const daysP2 = [
      "PoleAfterTime",
      "RaceAfterTime",
      "WinAfterTime",
      "PodiumAfterTime",
      "FastestLapAfterTime",
      "PointsAfterTime",
      "HatTricksAfterTime",
      "GrandChelemAfterTime",
    ];
    const lengthP1 = [
      "MinRaceTime1",
      "MinRaceTime2",
      "MinRaceTime3",
      "MaxRaceTime1",
      "MaxRaceTime2",
      "MaxRaceTime3",
    ];
    if (milestone.param2)
      translationValues.param2 = formatList(milestone.param2)!;
    if (milestone.param3)
      translationValues.param3 = formatList(milestone.param3)!;
    if (milestone.param4)
      translationValues.param4 = formatList(milestone.param4)!;

    if (milestone.param2) {
      if (daysP2.includes(milestone.key)) {
        translationValues.param2 = formatDaysToFriendlyText(milestone.param2);
      } else {
        translationValues.param2 = formatList(milestone.param2)!;
      }
    }
    if (lengthP1.includes(milestone.key)) {
      translationValues.param1 = convertRaceTime(translationValues.param1);
    }
    if (milestone.param3) {
      translationValues.param3 = formatList(milestone.param3)!;
    }

    if (milestone.param4) {
      if (datesP4.includes(milestone.key)) {
        translationValues.param4 = formatDateLocalized(milestone.param4);
      } else {
        translationValues.param4 = formatList(milestone.param4)!;
      }
    }

    return t(`milestones:${milestone.key}${plural}`, translationValues);
  };
  const convertRaceTime = (timeStr: string) => {
    // timeStr viene en formato XX:XX.XXX (ej: "01:23.456" o "125:45.123")
    const [minutesStr, rest] = timeStr.split(":");
    if (!rest) return timeStr; // Fallback por si el formato no es el esperado

    const [secondsStr, millisStr] = rest.split(".");

    const totalMinutes = parseInt(minutesStr, 10);
    const seconds = parseInt(secondsStr, 10);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Puedes adaptar los textos o pasarlos a tus archivos de traducción según el idioma
    const parts = [];

    if (hours > 0) {
      parts.push(`${hours} hora${hours > 1 ? "s" : ""}`);
    }

    if (minutes > 0 || hours > 0) {
      parts.push(`${minutes} minuto${minutes !== 1 ? "s" : ""}`);
    }

    // Siempre incluimos los segundos (puedes ajustar si quieres omitirlos si son 0)
    parts.push(`${seconds} segundo${seconds !== 1 ? "s" : ""}`);

    // Formatear con "y" antes del último elemento si hay más de uno
    if (parts.length > 1) {
      const last = parts.pop();
      return `${parts.join(", ")} y ${last}`;
    }

    return parts[0] || `${seconds} segundos`;
  };
  const formatDaysToFriendlyText = (daysStr: string) => {
    const days = parseInt(daysStr, 10);
    if (isNaN(days)) return daysStr;

    const years = Math.floor(days / 365);
    const remainingDays = days % 365;
    const months = Math.floor(remainingDays / 30);
    if (years > 0) {
      // Si los meses son mayores a 6 -> "más de X año y medio después"
      if (months > 6) {
        return t("milestones:time.years_and_half", { count: years });
      }
      // Si está entre 1 y 6 meses, o tiene días sueltos (> 0) -> "más de X año después"
      else if (months >= 1 || remainingDays > 0) {
        return t("milestones:time.years_exact", { count: years });
      }

      // Si es exacto (365 o 730 días clavados sin resto)
      return t("milestones:time.years_exact", { count: years });
    }
    const weeks = Math.floor(days / 7);
    if (weeks > 0) {
      return t("milestones:time.weeks", { count: weeks });
    }
    return t("milestones:time.days", { count: days });
  };

  // 2. Función para formatear fechas usando el idioma actual de i18n
  const formatDateLocalized = (dateStr: string) => {
    if (!dateStr) return dateStr;

    let date: Date;

    // Si el string viene en formato YYYY-MM-DD exacto
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // En JavaScript los meses van de 0 (Enero) a 11 (Diciembre)
      const day = parseInt(parts[2], 10);
      date = new Date(year, month, day);
    } else {
      // Por si viene en otro formato (ej. ISO completo con hora)
      date = new Date(dateStr);
    }

    if (isNaN(date.getTime())) return dateStr;

    return new Intl.DateTimeFormat(i18n.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  if (loading) return <LoadingContent />;
  if (grandPrix.name === "" || grandprix == null) return <ErrorPage />; //just in case gp name does not exist
  return (
    <div className="full-height padding-md app-container page-transition">
      <GrandPrixNavbar name={grandprix} active={1} />
      <div id="index-gp-container" className="row">
        <div className={widthCont}>
          <div
            className="flex"
            id={grandPrix.conference !== null ? "gp-data-withconf" : "gp-data"}
          >
            <div className="col-md-6">
              <div id="gp-overview" className="frame-turqoise frame-sm">
                <p className="main-title noBottomMargin frame-title">
                  {t("Summary").toUpperCase()}
                </p>
                <div id="summary-data-content">
                  <p className="flex">
                    <FontAwesomeIcon icon={faCalendarDay} />
                    <b>{t("Date")}: </b>
                    <DateFormat
                      date={grandPrix.date.toString()}
                      format={"normal"}
                    />
                  </p>
                  <p className="flex">
                    <FontAwesomeIcon icon={faLocationPin} />
                    <b>
                      {grandPrix.rally_circuits == null
                        ? t("Circuit")
                        : t("Stages")}
                      :{" "}
                    </b>
                    <span>
                      {grandPrix.rally_circuits == null
                        ? grandPrix.layout === null
                          ? `${grandPrix.circuit_name}`
                          : `${grandPrix.circuit_name} (${grandPrix.layout.replace(/\s+V\d+$/, "")})`
                        : `${grandPrix.rally_circuits}`}
                    </span>
                  </p>
                  {grandPrix.turns > 0 && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faBacon} />
                      <b>{t("Turns")}: </b>
                      <span>{grandPrix.turns}</span>
                    </p>
                  )}
                  {grandPrix.length != null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faRuler} />
                      <b>{t("Length")}: </b>
                      <span>
                        {parseFloat(grandPrix.length.toString()).toFixed(3)} km
                      </span>
                    </p>
                  )}
                  {grandPrix.country !== null && (
                    <p className="flex">
                      <FontAwesomeIcon icon={faMapLocation} />
                      <b>{t("Location")}: </b>
                      <span>
                        <Flag
                          flag_code={grandPrix.flag_code}
                          name={grandPrix.country}
                        />
                        {t(`countries:${grandPrix.country}`)}
                      </span>
                    </p>
                  )}
                  {typeRaces !== 1 && poleman != null && (
                    <SummaryDrivers
                      code="PO"
                      translation="Polesitter"
                      drivers={Array.isArray(poleman) ? poleman : [poleman]}
                      icon={faGaugeHigh}
                    />
                  )}
                  <SummaryDrivers
                    code="WI"
                    translation="Winner"
                    drivers={winner}
                    icon={faTrophy}
                  />
                  <SummaryDrivers
                    code="FL"
                    translation="HotLap"
                    drivers={fastestLap}
                    icon={faGaugeHigh}
                  />
                </div>
                {report.length > 0 && (
                  <div
                    className="race-report flex"
                    onClick={() => {
                      navigate(
                        `${t("routes:News")}/${
                          grandPrix.champ_name == null
                            ? "LVF1"
                            : grandPrix.champ_name.replace(/ /g, "")
                        }/${report[0].id}`,
                      );
                    }}
                  >
                    <img
                      alt={grandPrix.name}
                      src={`/assets/News/${report[0].id}/Image.jpg`}
                    />
                    <div>
                      <h4>
                        {i18n.language === "es"
                          ? report[0].title_es
                          : report[0].title_en}
                      </h4>
                      <span>
                        {i18n.language === "es"
                          ? report[0].caption_es
                          : report[0].caption_en}
                      </span>
                    </div>
                    <div className="read-more">{t("Report")}</div>
                  </div>
                )}
                {grandPrix.conference !== null && (
                  <div id="press-conference">
                    <iframe
                      id="audio_53222826"
                      scrolling="no"
                      height="200"
                      width="100%"
                      src={`https://www.ivoox.com/player_ej_${grandPrix.conference}_6_1.html?c1=101010`}
                      loading="lazy"
                    ></iframe>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 flex-around">
              <div id={circuitContainer} className="frame-turqoise frame-sm">
                <p className="main-title frame-title noBottomMargin">
                  {grandPrix.circuit_name.toUpperCase()}
                </p>
                <div>
                  {grandPrix.circuit_id !== null &&
                    (grandPrix.circuit_id.includes(",") ? (
                      <CircuitTransition
                        circuits_id={grandPrix.circuit_id}
                        circuits_name={grandPrix.rally_circuits}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ) : (
                      <CircuitLayout
                        circuit_id={grandPrix.circuit_id}
                        id_canvas={`circuit-${grandPrix.id}`}
                      />
                    ))}
                </div>
              </div>
              {milestones.length > 0 && (
                <div
                  id="milestones-container"
                  className="frame-turqoise frame-sm"
                >
                  <p className="main-title frame-title noBottomMargin">
                    {t("Milestones").toUpperCase()}
                  </p>
                  <div className="milestones-data">
                    {milestones.map((milestone: any, index) => {
                      return (
                        <p key={index}>
                          <FontAwesomeIcon icon={faCircleInfo} />{" "}
                          {milestone.milestone != null ? (
                            <React.Fragment>
                              {editingMilestoneIndex === index ? (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    width: "100%",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <input
                                    type="text"
                                    value={editedMilestoneText}
                                    onChange={(e) =>
                                      setEditedMilestoneText(e.target.value)
                                    }
                                    style={{ flex: 1, minWidth: "150px" }}
                                  />
                                  <button
                                    title="Guardar"
                                    onClick={() =>
                                      handleUpdateMilestone(milestone.id, index)
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faCheck}
                                      style={{ color: "green" }}
                                    />
                                  </button>
                                  <button
                                    title="Cancelar"
                                    onClick={() =>
                                      setEditingMilestoneIndex(null)
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "2px 5px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      style={{ color: "gray" }}
                                    />
                                  </button>
                                </span>
                              ) : (
                                <React.Fragment>
                                  {getMilestoneLinked(milestone.milestone)}
                                  {superMode && (
                                    <span
                                      style={{
                                        marginLeft: "8px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <button
                                        title="Editar"
                                        onClick={() => {
                                          setEditingMilestoneIndex(index);
                                          setEditedMilestoneText(
                                            milestone.milestone,
                                          );
                                        }}
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                          marginRight: "5px",
                                          padding: "2px",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faPen}
                                          style={{ fontSize: "0.85em" }}
                                        />
                                      </button>
                                      <button
                                        title="Eliminar"
                                        onClick={() =>
                                          handleDeleteMilestone(
                                            milestone.id,
                                            index,
                                          )
                                        }
                                        style={{
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                          padding: "2px",
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faTrash}
                                          style={{
                                            color: "#d9534f",
                                            fontSize: "0.85em",
                                          }}
                                        />
                                      </button>
                                    </span>
                                  )}
                                </React.Fragment>
                              )}
                            </React.Fragment>
                          ) : (
                            getMilestoneLinked(processMilestoneAuto(milestone))
                          )}
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-4">
          {grandPrix.pole_video && (
            <div className="video-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {(typeRaces !== 1
                  ? t("PoleVideo")
                  : t("FastestLapVideo")
                ).toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.pole_video}`}
              />
            </div>
          )}
          {grandPrix.gp_video && (
            <div className="video-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("GPVideo").toUpperCase()}
              </p>
              <iframe
                id="ytplayer"
                width="100%"
                allowFullScreen
                src={`https://www.youtube.com/embed/${grandPrix.gp_video}`}
              />
            </div>
          )}
          {photoGP !== "" && (
            <div className="image-container frame-turqoise frame-sm">
              <p className="main-title frame-title noBottomMargin">
                {t("PhotoGP").toUpperCase()}
              </p>
              <div className="flex-center">
                <img alt={grandPrix.name} src={photoGP} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GrandPrix;
